import { zonedHour } from "@/shared/i18n/datetime";

export type GreetingBand = "morning" | "forenoon" | "afternoon" | "evening";

export function greetingBand(now: Date, timeZone: string): GreetingBand {
  const hour = zonedHour(now, timeZone);
  if (hour >= 5 && hour < 10) return "morning";
  if (hour >= 10 && hour < 12) return "forenoon";
  if (hour >= 12 && hour < 18) return "afternoon";
  return "evening";
}
